import React from 'react';
import { makeStyles } from "@mui/styles";
import { Dialog, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';

import { X, TrashIcon } from 'lucide-react';

export default function DeleteDialog(props) {

    const classes = useStyles();
    const { t } = useTranslation();

    return (
        <Dialog className={classes.dialog}
            open={props.dialogOpen}
            onClose={props.closeDialog}

            classes={{ paper: classes.dialogPaper }}

            aria-labelledby="draggable-dialog-title"
        >
            <div className={classes.dialog__head}>
                <DialogTitle className={classes.dialog__title} id="draggable-dialog-title">
                    {t("Delete user")}
                </DialogTitle>
                <button onClick={() => props.closeDialog()} className={classes.dialog__closeButton}>
                    <X size={19} />
                </button>
            </div>
            <DialogContent className={classes.dialog__contentContainer}>
                <div className={classes.dialog__content}>
                    <p className={classes.dialog__subtitle}>{t("Are you sure you want to delete a user?")}</p>
                    <div className={classes.dialog__applicationContainer}>
                        <TrashIcon size={25}></TrashIcon>
                    </div>
                    <div className={classes.dialog__applicationButtonContainer}>
                        <button className={classes.dialog__applicationButton} onClick={() => props.deleteUser(props.selectedUser.Id)}>
                            {t("Yes")}
                        </button>
                        <button className={classes.dialog__applicationButton} onClick={() => props.closeDialog()}>
                            {t("No")}
                        </button>
                    </div>
                </div>
               
            </DialogContent>
        </Dialog >
    );
}

const useStyles = makeStyles(() => ({

    dialog: {
        margin: "auto"
    },

    dialogPaper: {
        width: '400px !important',
        height: 'auto',
        borderRadius: '6px !important',
    },

    dialog__head: {
        display: 'flex',
        justifyContent: 'space-between',
        alignItems: 'flex-start',

        padding: '16px 16px 0px 16px !important',
        marginBottom: '8px !important',
    },

    dialog__title: {
        fontSize: '24px !important',
        fontFamily: "Lato, sans-serif !important",
        fontWeight: 'normal',

        padding: '0px !important',
    },

    dialog__closeButton: {
        backgroundColor: '#F5F5F5',
        border: 'none',
        cursor: 'pointer',

        padding: '3px !important',
        height: '25px !important',

        borderRadius: '3px',

        transition: 'backgroundColor 0.2s, color 0.2s',

        '&:hover': {
            backgroundColor: '#D84949',
            color: '#F5F5F5',
        },

        '&:focus': {
            outline: '#4654FB auto 1px',
        },

    },

    dialog__contentContainer: {
        padding: '0px 16px !important',
        paddingBottom: '16px !important',

        // remove scrollbar
        '&::-webkit-scrollbar': {
            display: 'none',
        },
        '-ms-overflow-style': 'none',
        scrollbarWidth: 'none',

    },

    dialog__content: {
        display: 'flex',
        height: '100%',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'flex-start',

        margin: '0px !important',
    },

    dialog__subtitle: {
        fontSize: '16px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: '#0C0E29',

        margin: '0px 0px 16px 0px',
    },

    dialog__applicationContainer: {
        width: "100%",

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',
        marginBottom: '20px',
        gap: '8px',
    },

    dialog__applicationButtonContainer: {
        width: "100%",

        display: 'flex',
        flexDirection: 'column',
        justifyContent: 'flex-start',
        alignItems: 'center',

        gap: '8px',
    },

    dialog__applicationButton: {
        width: "100%",
        height: "54px",

        fontSize: '18px',
        fontFamily: "Lato, sans-serif",
        fontWeight: 'normal',

        color: '#0C0E29',

        backgroundColor: '#F8F8F8',
        border: 'none',
        cursor: 'pointer',

        padding: '8px 16px',
        borderRadius: '6px',

        border: "1px solid #EDEDED",

        transition: 'all 0.2s',

        '&:hover': {
            backgroundColor: '#4654FB',
            border: '1px solid #4654FB',
            color: '#F8F8F8',
        },

        '&:focus': {
            outline: '#4654FB auto 1px',
        },
    },
}));
